angular.module('assets')
    .component('assetDocumentList', {
        bindings: {
            page: '<',
            filters: '<'
        },
        templateUrl: 'app/asset/document/list.html',
        controller: function ($scope, $state, AssetDocumentService){
            this.reset = () => this.filters = {}
            this.AssetDocumentService = AssetDocumentService

            this.tags = [
                'PROJECT', 'SERVICE', 'PURCHASE', 'RENT', 'RETURN', 'SELL', 'DAMAGE'
            ];

            $scope.$on('asset-doc.updated', () => $state.reload());
        }
    })
